<template>
    <div class="accessory-card">
        <div class="accessory-image">
            <img :src="productImage" class="img-responsive">
        </div>
        <div class="accessory-content">
            <h6 class="accessory-title">{{ accessory.name }}</h6>
            <p class="accessory-description">
                {{ accessory.description }}
            </p>
            <color-picker
                v-if="accessory.variants[0].colors_code"
                :class="{ 'disable-element': isUpdating }"
                :product="productInCart || {}"
                :variants="accessory.variants"
                @select-variant="selectVariant"
            />
        </div>
        <div class="accessory-footer">
            <multiselect
                v-if="shouldShowQuantityDropdown"
                v-model="qty"
                :allow-empty="false"
                :class="{ 'disable-element': isUpdating }"
                :disabled="isUpdating"
                :options="[1, 2, 3]"
                :searchable="false"
                :show-labels="false"
                @input="variantInCart && updateAccessories(qty)"
            />
            <p class="accessory-price">{{ accessory.variants[0].price | formatMoney }}</p>
        </div>

        <button
            v-if="!productInCart"
            :class="{ 'disable-element': isUpdating }"
            :disabled="isUpdating"
            type="button"
            class="btn btn-block add-to-cart"
            @click="updateAccessories(qty)"
        >
            ADD TO CART
        </button>
        <button
            v-else
            :class="{ 'disable-element': isUpdating }"
            :disabled="isUpdating"
            type="button"
            class="btn btn-block btn-purple btn-outline remove-from-cart"
            @click="removePart(accessory.variants[0])"
        >
            REMOVE FROM CART
        </button>
    </div>
</template>

<script>
import CONSTANTS from "../../../../config/constants";
import accessoriesMixin from "../accessories-mixin";
import ColorPicker from "./color-picker";

export default {
    name: "AccessoryCard",
    components: {
        ColorPicker
    },
    mixins: [
        accessoriesMixin
    ],
    data() {
        return {
            CONSTANTS
        }
    },
    computed: {
        shouldShowQuantityDropdown() {
            const isHeadset = this.accessory.variants[0].peripherals_types_id == CONSTANTS.PERIPHERALS.HEADSET;
            const isBundle = this.accessory.variants[0].hasOwnProperty('bundles_types_id');

            return !isHeadset && !isBundle;
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./accessory-style";
</style>

<style lang="scss">
@import "./multiselect-style";
</style>
